import styled from 'styled-components';

export const FormTitleWrapper = styled.div`
  padding: 20px 0 24px 0;
  font-weight: 600;
  font-size: 14px;
  color: #656464;
  border-bottom: 1px solid #d2d3d4;
`;
